// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmartSurveyPushBlock-module-smartSurveyPushBlock-2t8PG{background-color:#fff;background-color:var(--des-color-fill-panel-base, #fff)}", ""]);
// Exports
exports.locals = {
	"smartSurveyPushBlock": "SmartSurveyPushBlock-module-smartSurveyPushBlock-2t8PG"
};
module.exports = exports;
